document.addEventListener('DOMContentLoaded',addUriToShareButtons);

function addUriToShareButtons() {
    // alle wrapper finden, in denen share-buttons zu finden sind
    const shareButtonsWrappers = document.querySelectorAll('[data-component="share_buttons"]');
    shareButtonsWrappers.forEach((wrapper) => {
        const shareButtons = wrapper.querySelectorAll('a');
        // in jedem wrapper die share-buttons ergaenzen
        shareButtons.forEach(button => {
            // Buttons deren href schon via javascript gesetzt wird nicht ergaenzen
            if(!button.href.startsWith("javascript")){
                button.href += encodeURIComponent(window.location.href);
            }
        })
    });

}
